import * as React from "react";
import ExternalLink from "../../../../../../../components/Navigation/ExternalLink";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli, CommonBuildServerPackagingTextForIntegration } from "../CommonRegistrationText";
export const BuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging .NET Core applications from build servers, we recommend using <code>dotnet publish</code> on the project followed by <code>octopus package (nuget|zip) create</code> using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>{" "}
            on the output directory.
        </p>
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
        <p>
            The <ExternalLink href="GuidesASPNetCore">ASP.NET Core guides</ExternalLink> provide step by step instructions for deploying ASP.NET Core applications.
        </p>
    </div>);
BuildServerPackaging.displayName = "BuildServerPackaging"
export default buildServerPackagingInstruction(() => <BuildServerPackaging />);
